import PillGenerator from "./PillGenerator";

export default PillGenerator;
